import { useAtom, useAtomValue } from 'jotai';
import { useCallback } from 'react';

import type { PaymentStatusAtom } from '$business/atoms/payment-status';

import { paymentStatusAtom } from '$business/atoms/payment-status';
import { ZPaymentStatusSchema } from '$src/models/state/payment-status';

export function usePaymentStatusAtom() {
  const [paymentStatus, setPaymentStatus] = useAtom(paymentStatusAtom);

  const onPaymentStatusChange = useCallback(
    (status: PaymentStatusAtom) => {
      const safeMessage = ZPaymentStatusSchema.safeParse(status);

      if (safeMessage.success) {
        setPaymentStatus(safeMessage.data);
      } else {
        console.error('Error while parsing payment status change', {
          error: safeMessage.error,
          hook: usePaymentStatusAtom.name,
        });
      }
    },
    [setPaymentStatus],
  );

  return { paymentStatus, onPaymentStatusChange };
}

export function useROPaymentStatusAtom() {
  return useAtomValue(paymentStatusAtom);
}
